import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function Objections() {
  return <Section className="bg-white" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-250">
          “Pero yo…”{' '}
          <span className="text-gray-500 font-normal text-xl block mt-2" data-id="element-251">
            (lo que piensan casi todas al inicio)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-252">
          {[{
          title: '“No soy experta.”',
          desc: 'Perfecto. Las personas compran soluciones prácticas, no diplomas.'
        }, {
          title: '“No tengo tiempo.”',
          desc: 'Por eso es 7 días y en bloques pequeños. Esto está hecho para tu realidad.'
        }, {
          title: '“Me da pena vender.”',
          desc: 'Aquí no vendes como “vendedora”. Vendes como mamá ayudando a otras con algo útil.'
        }, {
          title: '“No sé diseñar.”',
          desc: 'Gamma App se encarga del look profesional. Tú solo sigues instrucciones.'
        }].map((obj, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-253">
              <div className="flex items-start mb-3" data-id="element-254">
                <CheckCircle2 className="w-6 h-6 text-brand-pink mr-3 flex-shrink-0" data-id="element-255" />
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-256">{obj.title}</h3>
              </div>
              <p className="text-gray-600 ml-9" data-id="element-257">{obj.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}